import '../scss/index.scss';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper/bundle';

import './animations/general';
import './animations/home';
import './animations/progetto';
import './animations/territorio';
import './animations/champagne';
import './animations/single-champagne';
import './animations/blog';
import './animations/mixology';

// Slider Notizie
if (document.querySelector('.slider-news')) {
    var swiperNotizie = new Swiper('.slider-news', {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      }
    });
}

if (document.querySelector('.slider-ambiente')) {
  var swiperAmbiente = new Swiper('.slider-ambiente', {
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
      },
      loop: true
  });
}

if (document.querySelector('.slider-single')) {
  var swiperSingle = new Swiper('.slider-single', {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      },
      
  });
}

// Inizializzazione JQuery
jQuery(document).ready(function($) {

  // PopUp Menu
  $('.header__menu').on('click', function() {
    if ($(this).hasClass('open')) {
      $(this).removeClass('open');
      $('body').removeClass('menu-open');
    } else {
      $(this).addClass('open');
      $('body').addClass('menu-open');
    }
  });

  var position = $(window).scrollTop(); 
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
      if(scroll > position) {
        $('header').addClass('scroll');
      } else {
        $('header').removeClass('scroll');
      }
    position = scroll;
  });

  if ($('#svg-image').length > 0) {
    $('#svg-image').each((index, item) => {
        var response = '';
        var url = item.getAttribute('src');

        $.ajax({ 
            type: "GET",   
            url: url,   
            async: false,
            success : function(data)
            {
                response = $(data).find('svg').get(0).outerHTML;
                item.outerHTML = response;
            }
        });
    });      
  }


  // ANIMAZIONI LANDING PAGE

  //     var tl = gsap.timeline();
  //     tl.from('body', {duration: 1, backgroundColor: "#111", ease: "power4.out"});
      
  //     if ($('main').length > 0) {
  //         var tl = gsap.timeline();
  //         tl.from('main', {delay: 0.5, duration: 1, opacity: 0, ease: "power4.out"});
  //     }

  //     if($('main img').length > 0) {
  //         $('main img').each(function() {
  //             var tl = gsap.timeline();
  //             tl.from(this, {delay: 1, duration: 1, opacity: 0, y:-20, ease: "power4.out"});
  //         });
  //     }

  //     if($('main h1').length > 0) {
  //         $('main h1').each(function() {
  //             var tl = gsap.timeline();
  //             tl.from(this, {delay: 1.3, duration: 1, opacity: 0, y:20, ease: "power4.out"});
  //         });
  //     }

  //     if($('main p').length > 0) {
  //         $('main p').each(function() {
  //             var tl = gsap.timeline();
  //             tl.from(this, {delay: 1.5, duration: 1, opacity: 0, y:20, ease: "power4.out"});
  //         });
  //     }

  //     if($('main a').length > 0) {
  //         var tl = gsap.timeline();
  //         tl.from('main a', {delay: 2, stagger: 0.2, duration: 1, opacity: 0, y:20, ease: "power4.out"});
  //     }




  // FILTRI AJAX

  //JS

  // $('.filters-container button').on('click', function() {
  //   $('.filters-container button').removeClass('active');
  //   $(this).addClass('active');

  //   $.ajax({
  //     type: 'POST',
  //     url: '/wp-admin/admin-ajax.php',
  //     dataType: 'html',
  //     data: {
  //       action: 'filter_posts',
  //       category: $(this).attr('id'),
  //     },

  //     success: function(res) {
  //       $('.posts .blog').html(res);
  //     }

  //   });

  // });

  
  //PHP

  // function filter_posts() {


  //   $cat_ID = isset( $_POST['category'] ) && ! empty( $_POST['category'] ) ? sanitize_text_field( wp_unslash( $_POST['category'] ) ) : '';

  //   $query_args = array(
  //       'post_type'      => 'post',
  //       'posts_per_page' => 8,
  //       'orderby'        => 'date',
  //       'order'          => 'DESC',
  //   );

  //   if ( ! empty( $cat_ID ) ) {
  //       $query_args['cat'] = $cat_ID;
  //   }

  //   $ajaxposts = new WP_Query( $query_args );

  //   ob_start();

  //   if ( $ajaxposts->have_posts() ) {
  //       $i = 1;
  //       while ( $ajaxposts->have_posts() ) {
  //           $ajaxposts->the_post();
  //           $class = '';
  //           if ($i % 4 == 0 || $i % 4 == 1) {
  //               $class = 'big';
  //           }
  //           ?>
  //               <div class="post <?php echo $class ?>" style="background-image: url(<?php echo get_the_post_thumbnail_url( get_the_ID(), 'full' ); ?>)">
  //                   <a href="<?php echo get_the_permalink(); ?>">
  //                       <div class="overlay">
  //                           <p>
  //                               <?php
  //                               if ( get_the_tags() ) {
  //                                   foreach ( get_the_tags() as $tag ) {
  //                                       echo $tag->name;
  //                                   }
  //                                   echo ' - ';
  //                               }
  //                               ?><?php echo get_the_date( 'd.m.Y' ) ?></p>
  //                           <h6 style="font-family: var(--font-lato-bold); font-weight: 700"><?php echo get_the_title(); ?></h6>
  //                       </div>
  //                   </a>
  //               </div>
  //           <?php
  //           $i++;
  //       }
      
  //       echo paginate_links( array(
  //           'base'         => str_replace( 999999999, '%#%', esc_url( get_pagenum_link( 999999999 ) ) ),
  //           'total'        => $ajaxposts->max_num_pages,
  //           'current'      => max( 1, get_query_var( 'paged' ) ),
  //           'format'       => '?paged=%#%',
  //           'show_all'     => false,
  //           'type'         => 'plain',
  //           'end_size'     => 2,
  //           'mid_size'     => 1,
  //           'prev_next'    => true,
  //           'prev_text'    => sprintf( '<i></i> %1$s', __( 'Newer Posts', 'text-domain' ) ),
  //           'next_text'    => sprintf( '%1$s <i></i>', __( 'Older Posts', 'text-domain' ) ),
  //           'add_args'     => false,
  //           'add_fragment' => '',
  //       ) );
  //   }

  //   wp_reset_postdata();
  //   $response = ob_get_clean();
  //   echo $response;
  //   exit;
  // }

  // add_action( 'wp_ajax_filter_posts', 'filter_posts' );
  // add_action( 'wp_ajax_nopriv_filter_posts', 'filter_posts' );


});

if (document.querySelector(".single-mixology")) {
    let mm = gsap.matchMedia();

    mm.add({
        isMobile: "(max-width: 767px)",
        isDesktop: "(min-width: 768px)"
    }, (context) => {
        const offset = context.conditions.isMobile ? 100 : 200;

        // Hero Title
        const heroTitle = document.querySelector(".hero h1");
        if (heroTitle) {
            gsap.from(heroTitle, {
                opacity: 0,
                y: -20,
                duration: 1,
                delay: 0.3,
            });
        }

        // Hero Image
        const heroImage = document.querySelector(".hero-image");
        if (heroImage) {
            gsap.from(heroImage, {
                opacity: 0,
                scale: 1.1,
                duration: 1,
                ease: "power2.out",
                delay: 0.5,
            });
        }

        // Contenuto testuale
        const textElements = gsap.utils.toArray([
            "#content h2",
            "#content p",
            "#content .grid--1-2 > div"
        ]);

        textElements.forEach(el => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: "top bottom-=" + offset,
                    once: true
                },
                opacity: 0,
                y: 30,
                duration: 0.8,
                ease: "power2.out"
            });
        });
    });
}